import { data } from "autoprefixer";
import client from "./axiosConfig";

export const TrendingProducts = () => {
  const config = {
    url: `trending_products/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const AddToCart = (data) => {
  const config = {
    url: `cart/add/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const ViewCart = () => {
  const config = {
    url: `cart/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const ViewWishlist = () => {
  const config = {
    url: `wishlist/list/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const DeleteWishlist = (id) => {
  const config = {
    url: `wishlist/${id}/`,
    method: "DELETE",
  };
  return client(config);
};

export const AddToWishlist = (data) => {
  const config = {
    url: `wishlist/add/`,
    method: "POST",
    data,
  };
  const response = client(config);
  return response;
};

export const getProducts = (payload) => {
  const config = {
    url: `products/`,
    method: "GET",
    params: payload,
  };
  const response = client(config);
  return response;
};

export const NewArrivals = () => {
  const config = {
    url: `new_arrival_products/`,
    method: "GET",
  };
  const response = client(config);
  return response;
};

export const GetProductDetailById = (pro_id) => {
  const config = {
    url: `ProductsDetails/${pro_id}/`,
    method: "GET",
  };
  return client(config);
};

export const GetOrderDetailsById = (orderId) => {
  const config = {
    url: `orders-det/${orderId}`,
    method: "GET",
  };
  return client(config);
};

export const DownloadInvoice = (orderId) => {
  const config = {
    url: `invoice_download/`,
    method: "POST",
    data: {
      order_id: orderId,
    },
  };
  return client(config);
};

export const UpdateCart = (cart_id, payload) => {
  const config = {
    url: `cart/${cart_id}/`,
    method: "PATCH",
    data: payload,
  };
  return client(config);
};

export const DeleteCartItem = (cart_id) => {
  const config = {
    url: `cart/${cart_id}/`,
    method: "DELETE",
  };
  return client(config);
};

export const FetchProfile = () => {
  const config = {
    url: `user-profile/`,
    method: "GET",
  };

  return client(config);
};

export const UpdateProfile = (data) => {
  const config = {
    url: `user-profile/`,
    method: "PATCH",
    data: data,
  };

  return client(config);
};

export const FetchCollections = (category) => {
  const config = {
    url: `collections/${category}/`,
    method: "GET",
  };

  return client(config);
};

export const FetchProductsByCategory = (category, subCategory) => {
  const config = {
    url: `products/`,
    method: "GET",
    params: {
      category,
      sub_category: subCategory,
    },
  };
  return client(config);
};

export const GetAddresses = () => {
  const config = {
    url: `user-profile/addresses/`,
    method: "GET",
  };
  return client(config);
};

export const CreateAddress = (data) => {
  const config = {
    url: `user-profile/addresses/`,
    method: "POST",
    data,
  };
  return client(config);
};

export const UpdateAddress = (id, data) => {
  const config = {
    url: `user-profile/addresses/${id}/`,
    method: "PATCH",
    data,
  };
  return client(config);
};

export const DeleteAddress = (id) => {
  const config = {
    url: `user-profile/addresses/${id}/`,
    method: "DELETE",
  };
  return client(config);
};

export const addUserAddress = () => {
  const config = {
    url: `user-profile/addresses/`,
    method: "POST",
  };

  return client(config);
};

export const getUserAddress = () => {
  const config = {
    url: `user-profile/addresses/`,
    method: "GET",
  };

  return client(config);
};

export const placeOrder = (payload) => {
  const config = {
    url: `orders/create/`,
    method: "POST",
    data: payload,
  };

  return client(config);
};

export const getServiceOrderList = (payload) => {
  const config = {
    url: `order_by_status/`,
    method: "GET",
    params: payload,
  };

  return client(config);
};

export const ReviewProduct = (payload) => {
  const config = {
    url: `products_rating/`,
    method: "POST",
    data: payload,
  };
  return client(config);
};

export const GetProductReview = (productId) => {
  const config = {
    url: `products_rating/?product_id=${productId}`,
    method: "GET",
  };
  return client(config);
};

export const ReadNotification = (ids) => {
  const config = {
    url: "notifications/",
    method: "POST",
    data: { ids },
  };
  return client(config);
};

export const GetNotifications = (url) => {
  const config = {
    url,
    method: "GET",
  };
  return client(config);
};

export const ExchangeOrder = (data) => {
  const config = {
    url: "orders/return-exchange/",
    method: "POST",
    data,
  };
  return client(config);
};

export const addPaymentResponse = (payload) => {
  const config = {
    url: `payment/callback/`,
    method: "POST",
    data: payload,
  };
  return client(config);
};

export const FetchSimilarProducts = (pro_id) => {
  const config = {
    url: `similar-products/${pro_id}`,
    method: "GET",
  };
  return client(config);
};

export const GetContent = (category) => {
  const config = {
    url: `content/${category}/`,
    method: "GET",
  };
  return client(config);
};

export const FetchBlockbusterDeal = () => {
  const config = {
    url: `blockbuster_products/`,
    method: "GET",
  };
  return client(config);
};

export const FetchLatestNews = () => {
  const config = {
    url: `latest_news/`,
    method: "GET",
  };
  return client(config);
};

export const ExchangeReturn = (payload) => {
  const config = {
    url: `orders/return-exchange`,
    method: "POST",
  };
  return client(config);
};

export const GetCoupons = () => {
  const config = {
    url: `coupons_available/`,
    method: "GET",
    // params: { user_id } // <-- send user_id as query param
  };
  return client(config);
};

export const FetchFilters = (payload = {}) => {
  // console.log("Payload:", payload);

  const config = {
    url: `filters/`,
    method: "GET",
    params: payload,
  };
  return client(config);
};

export const CheckMobileNumber = (mobile) => {
  const config = {
    url: `check-mobile/?mobile_no=${mobile}`,
    method: "GET",
  };
  return client(config);
};

export const CheckEmail = (email) => {
  const config = {
    url: `check_email/?email=${email}`,
    method: "GET",
  };
  return client(config);
};

export const getShippingCharges = (payload) => {
  const config = {
    url: `shipping_charges`,
    method: "GET",
    params: payload,
  };

  return client(config);
};

export const getBanners = (payload = {}) => {
  const config = {
    url: `banners/`,
    method: "GET",
    params: payload,
  };

  return client(config);
};

export const getPaymentData = (payload = {}) => {
  const config = {
    url: `payment_history/`,
    method: "GET",
    params: payload,
  };

  return client(config);
};

export const checkStock = (payload) => {
  const config = {
    url: `check_stock/`,
    method: "POST",
    data: payload,
  };
  return client(config);
};
